import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import { formatViews } from "@/utils/movies";

interface MovieCardProps {
  movie: Movie;
  className?: string;
}

export default function MovieCard({ movie, className = "" }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className={`group block cursor-pointer ${className}`}
    >
      <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - ${movie.typeName}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/70 to-transparent" />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-black/55 text-background-50 text-[11px] font-medium backdrop-blur-sm">
          {movie.typeName}
        </span>
        <span className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-[11px] font-bold">
          <i className="ri-star-fill text-[10px]"></i>
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-2 left-2 text-background-50 text-[11px] flex items-center gap-1">
          <i className="ri-fire-line"></i>
          {formatViews(movie.views)}次观看
        </span>
        <span className="absolute bottom-2 right-2 text-background-50 text-[11px]">
          {movie.episodes > 1 ? `更新至${movie.episodes}集` : "全1集"}
        </span>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
          {movie.region} · {movie.year} · {movie.genres.slice(0, 2).join(" ")}
        </p>
      </div>
    </Link>
  );
}